import Cookies from "js-cookie";

/**
 *
 * Other components can interact with this cookie by sending an event like
 * const wordCompletedEvent = new CustomEvent(
 *  "dictionary.addWord",
 *  {
 *      detail: {
 *          nation : 'ma nation',
 *          word: 'mon mot'
 *          }
 *          });
 * document.dispatchEvent(wordCompletedEvent);
 *
 */
export default class DictionaryCookie
{
    constructor ()
    {

        this.cookieName = 'savoirs-legendaires-dictionnaire';

        this.existingValues = {
            completedDictionaryWords : [],
        };

        this.getCookie();
        this.bindEvents();
    }

    bindEvents ()
    {
        window.addEventListener( 'dictionary.addWord', ( event ) =>
        {
            this.saveDictionaryCompletion( event.detail.nation, event.detail.word )
        } )

        window.addEventListener( 'dictionary.reset', ( event ) =>
        {
            this.resetCookie();
        } )
    }

    getCookie ()
    {
        let existingValues = Cookies.get( this.cookieName );

        if ( !existingValues || typeof existingValues === 'undefined' )
        {
            existingValues = {}
        } else
        {
            existingValues = JSON.parse( existingValues );
        }
        this.existingValues = Object.assign( {}, this.existingValues, existingValues )

        // console.log( 'Current user options from cookie = ', this.existingValues )
        this.updateValues();
    }

    resetCookie ()
    {
        // console.log('[DictionaryCookie] Cookie reset.')
        Cookies.remove( this.cookieName );
    }

    saveCookie ()
    {
        Cookies.set( this.cookieName, JSON.stringify( this.existingValues ) );
    }

    saveDictionaryCompletion ( nation, word )
    {
        // console.log( 'Saving dictionary word completed: ', { nation, word } );

        this.existingValues.completedDictionaryWords.push( { nation, word } );

        this.updateValues();
    }


    updateValues ()
    {

        this.saveCookie();
        window.SavoirsLegendairesUserWords = this.existingValues.completedDictionaryWords;


    }

}


export function dictionaryCookieReset ()
{
    const resetEvent = new CustomEvent( 'dictionary.reset' );
    window.dispatchEvent( resetEvent );
}

export function dictionaryCookieAddWord ( word, nation )
{

    const addWordEvent = new CustomEvent( 'dictionary.addWord', {
        detail: {
            nation,
            word,
        }
    } );
    window.dispatchEvent( addWordEvent );
}
